import { SEND_SMS_REQUEST, SEND_SMS_SUCCESS, SEND_SMS_FAILURE } from '../actions/types'
import { serviceUrl } from '../actions/types';
// Thunk action to send the confirmation SMS
export const sendConfirmationSms = (smsPayload) => async (dispatch) => {
  dispatch({ type: SEND_SMS_REQUEST });

  const token = localStorage.getItem('token');
  if (!token) {
    const errorMsg = "SMS Error: Authentication token not found.";
    console.error(errorMsg);
    dispatch({ type: SEND_SMS_FAILURE, payload: errorMsg });
    return;
  }

  try {
    const response = await fetch(`${serviceUrl}/api/appointmentNotification/sms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(smsPayload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'SMS notification failed');
    }

    const successData = await response.json();
    console.log("SMS notification sent successfully.");
    dispatch({ type: SEND_SMS_SUCCESS, payload: successData });

  } catch (error) {
    console.error("Error sending SMS notification:", error);
    dispatch({ type: SEND_SMS_FAILURE, payload: error.message });
  }
};